import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import App from './App.tsx';
import './index.css';

console.log('Booting Stradamus app, VITE_ALLOW_BROWSER_ACCESS=', import.meta.env.VITE_ALLOW_BROWSER_ACCESS);

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>
);
